import { render, staticRenderFns } from "./jx3.vue?vue&type=template&id=29843548&"
import script from "./jx3.vue?vue&type=script&lang=js&"
export * from "./jx3.vue?vue&type=script&lang=js&"
import style0 from "./jx3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports